import { useSurgery } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { surgerySchema } from '@schema/pDirectory.schema'
import { DateInputField, FormButton, FormInputField, Modal } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import { useParams, useSearchParams } from 'react-router-dom'

type Props = {
  onClose: () => void
}

const AddSurgical = ({ onClose }: Props) => {
  const { patientId, intakeId: id } = useParams<string>()
  const methods = useForm({ resolver: yupResolver(surgerySchema) })

  const { handleSubmit, formState, reset } = methods

  const { createSurgery } = useSurgery({})
  const [searchParams] = useSearchParams()
  const intakeId = searchParams.get('intake') || id

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data
        },
        relationships: intakeId
          ? {
              intake: {
                data: {
                  id: intakeId,
                  type: 'intake'
                }
              },
              patient: {
                data: {
                  id: patientId,
                  type: 'patient'
                }
              }
            }
          : {
              patient: {
                data: {
                  id: patientId,
                  type: 'patient'
                }
              }
            },
        type: 'surgical_history'
      }
    }
    try {
      await createSurgery(payload)
      onClose()
      showToast('Surgery created successfully')
    } catch (error) {
      getError(error)
    }
  }
  // return (
  //   <FormProvider {...methods}>
  //     <Modal title="Add Surgery" onClose={onClose} reset={methods.reset}>
  //       <Form
  //         onSubmit={methods.handleSubmit(onSubmit)}
  //         style={{ display: 'flex', flexDirection: 'column', overflow: 'auto' }}
  //       >
  //         <Box
  //           pad="medium"
  //           style={{ display: 'block', scrollbarWidth: 'thin', scrollbarColor: '#fff' }}
  //           overflow={'auto'}
  //         >
  //           <Box>
  //             <FormInputField name="surgery_type" label="Surgery name" />
  //           </Box>
  //           <Box>
  //             <DateInputField label="Date" name="surgery_date" />
  //           </Box>
  //           <Box>
  //             <FormInputField name="location" label="Location" />
  //           </Box>
  //         </Box>
  //         <Box
  //           direction="row"
  //           border={{ side: 'top', size: 'xsmall' }}
  //           flex={false}
  //           width="100%"
  //           height={'100px'}
  //           background={'white'}
  //           pad={{ vertical: '10px', horizontal: '32px' }}
  //           style={{ zIndex: 10, borderBottomLeftRadius: '15px', borderBottomRightRadius: '15px' }}
  //           justify="end"
  //           as="footer"
  //           align="center"
  //         >
  //           <Button
  //             label={'Cancel'}
  //             icon={<Close size="small" color="black" />}
  //             margin={{ right: 'small' }}
  //             onClick={onClose}
  //             type="button"
  //             pad={{ vertical: '12px', horizontal: '16px' }}
  //             style={{ color: 'black', fontSize: '16px', fontWeight: 'normal' }}
  //             color="#F5F5F5"
  //             secondary
  //           />
  //           <Button
  //             label="Save"
  //             icon={<Checkmark size="16px" />}
  //             isLoading={methods.formState.isSubmitting}
  //             type="submit"
  //             pad={{ vertical: '12px', horizontal: '16px' }}
  //             style={{ fontSize: '16px', fontWeight: 'normal' }}
  //             primary
  //           />
  //         </Box>
  //       </Form>
  //     </Modal>
  //   </FormProvider>
  // )

  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} reset={reset} title="Add Surgery">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box
            flex={false}
            pad={{ horizontal: '32px', vertical: '16px' }}
            style={{
              overflowX: 'hidden',
              overflowY: 'auto',
              minHeight: '450px'
            }}
            width={'100%'}
          >
            <div className="flex flex-col gap-4 py-4">
              <Box>
                <FormInputField label="Surgery name" name="surgery_type" />
              </Box>
              <Box>
                <DateInputField label="Date" name="surgery_date" />
              </Box>
              <Box>
                <FormInputField label="Location" name="location" />
              </Box>
            </div>
          </Box>
          <Box style={{ background: '#fff', bottom: 0, position: 'sticky', zIndex: 20 }}>
            <FormButton isLoading={formState.isSubmitting} onClose={onClose} submit="Save" type="submit" />
          </Box>
        </Form>
      </Modal>
    </FormProvider>
  )
}

export default AddSurgical
